module.exports = __webpack_public_path__ + "img/jd-exp.1cbe7538.svg";